FairplayerImageVue(:url='url' :resolution='ImageResolution.LG' ref='banner' :alt='t("logo.alt.banner")' :fallback-image='FairplayerFallbackImageUi.BANNER' :style='`transform: translateY(${bannerTranslateY}px);`')
